<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search
        :data="tableFilterList(seachList)"
        @search="dataTableSearch"
      >
        <template v-slot:next>
          <el-button
            icon="el-icon-upload2"
            @click="weekExport()"
            >导出</el-button
          >
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="tableData"
        :editable="false"
        :total="total"
        :offset="offset"
        :page="page"
        border
        :loading="loading"
        stripe
        :cell-style="cellStyle"
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
        :toolBar="{hidden: true}"
      >
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>

import "@/components/EditDataTable"
import DynamicSearch from "@/components/DynamicSearch"
import DataTableMixin from "@/mixins/DataTableMixin"
import { tableSataus } from '@/views/bill/mixins/status'
import initDict from "@/mixin/initDict";
import { GetMonday } from '@/utils'
import { downloadExcel } from "@/api/bill/ProjectPlan";
export default {
  name: "ContractIndex",
  components: { DynamicSearch },
  mixins: [DataTableMixin, tableSataus, initDict],
  data () {
    return {
      contractTypeItems: {},
      tableHead: [
        {
          label: '项目',
          prop: 'projectName',
          query: {
            type: "input"
          }
        },
        {
          label: '部门',
          prop: 'orgCode',
          query: {
            type: "input"
          }
        },
        {
          label: '人员',
          prop: 'personName',
          query: {
            type: "input"
          }
        },
      ],
      seachList: [
          {
          label: '开始周',
          prop: 'startDate',
          query: {
            type: "dateWeek",
            clearable: false
          }
        },
        {
          label: '结束周',
          prop: 'endDate',
          query: {
            type: "dateWeek",
            clearable: false
          }
        },
      ],
      tableData: [],
      startTime: '',
      endTime: '',
      daysMap: {}
    }
  },
  watch: {
    list: {
        handler(val) {
            if (val.hasOwnProperty('tableHead')) {
              this.tableHead = val.tableHead
            }
            if (val.hasOwnProperty('homeList')) {
              this.tableData = val.homeList.map(d => {
                if (d.jobList && d.jobList.length) {
                    d.jobList.forEach(j => {
                        d[j.taskWeek] = j.projectNames.substring(0, j.projectNames.lastIndexOf(','))
                        d[j.taskWeek + 'whetherFull'] = j.whetherFull
                    })
                }
                return d
              })
            } else {
              this.tableData = []
            }
        }
    }
  },
  created () {
    this.$nextTick(() => {
        this.seachList = this.seachList.concat(this.tableHead)
        this._query.startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);// 当月1号
        this._query.endDate = new Date()
        this.dataTableInit()
    });
  },
  methods: {
    weekExport() {
      this._query.whetherWeek = '1'
      downloadExcel('/resourceForm/exportResource', this._query, '资源周看板')
    },
    dataTableBeforeInit () {
      this._url = "/resourceForm/resouceForWeek"
      const params = { page: this.page, size: this.offset,whetherWeek: '1' }
      if (!this._query.startDate) {
        this.$notify({title: '请选择开始周', type: 'warning',duration: 2500})
        return false
      }
      if (!this._query.endDate) {
        this.$notify({title: '请选择结束周', type: 'warning',duration: 2500})
        return false
      }
      this._query.start = GetMonday(new Date(this._query.startDate), 1)
      this._query.end = GetMonday(new Date(this._query.endDate), 7)
      if (new Date(this._query.end) < new Date(this._query.start)) {
        this.$notify({
          title: '结束周不能小于周',
          type: 'warning',
          duration: 2500
        })
        return false
      }
      this._params = Object.assign(params, this._query)
      return true
    },
    cellStyle({row, column, rowIndex, columnIndex}) {
        if (columnIndex < 2) {
          return ''
        }
        if (row.hasOwnProperty(column.property)) {
            if (row[column.property + 'whetherFull'] === '0') {
                 return 'background: #ffff00';
            } else {
                return '';
            }
        } else {
            return 'background: #ff7c80;';
        }
    },
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-table--border td {
  border-right: 1px solid #dfe6ec !important;
}
</style>
